import { Redirect, useLocalSearchParams } from 'expo-router';

import { useLastInteractedStore } from '../../context/LastInteractedStore';
import { useIsCustomerAddress } from '../../hooks';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A "placeholder" route that always redirects users to the menu or delivery
 * menu route when the last-interacted slug/address is available, or to the
 * location selection route otherwise.
 */
export const MenuWithoutSlug = () => {
  const lastInteractedStore = useLastInteractedStore();
  const { category } = useLocalSearchParams<{ category?: string }>();

  const { restaurantSlug, addressId } = lastInteractedStore ?? {};

  const isCustomerAddress = useIsCustomerAddress(addressId);

  // ─────────────────────────────────────────────────────────────────────

  const hasValidMenuRouteSlug = restaurantSlug !== undefined;
  const hasValidDeliveryMenuRouteSlug = addressId !== undefined && isCustomerAddress;
  const categoryParam = category ? { category } : {};

  // ─────────────────────────────────────────────────────────────────────

  if (hasValidDeliveryMenuRouteSlug) {
    return (
      <Redirect
        href={{ pathname: '/delivery/[addressId]/menu', params: { addressId, ...categoryParam } }}
      />
    );
  }

  if (hasValidMenuRouteSlug) {
    return (
      <Redirect
        href={{ pathname: '/[restaurantSlug]/menu', params: { restaurantSlug, ...categoryParam } }}
      />
    );
  }

  return <Redirect href={{ pathname: '/locations', params: categoryParam }} />;
};
